<template>
  <div style="margin: 1rem; padding: 1rem;" class="bg-modal" @click.stop>

    <!-- Header -->
    <text-item :txt="expr.originalText" styles="main-h font-l"/>

      <!-- refresh -->
    <div class="row gap-10 mtop-08">
      <buttonGroup class="row gap-06 padButton-m" styles="border-vl" @click="fullExprToConsole()">
        <svg-item icon="fileText" styles="size-m main-m"/>
        <text-item txt="Full console log" styles="main-m"/>
      </buttonGroup>
    </div>

    <div class="subgrid col gap-06 mtop-10">
      <!-- Site Finding -->
      <template v-if="siteFindingRoot">
        <div class="rowend mtop-10">
          <text-item txt="Site Finding" styles="font-mBold"/>
        </div>
        <div>
          <text-item :txt="siteFindingRoot" class="mtop-10 main-m "/>
        </div>
        <template v-if="expr.sctSiteFinding">
          <div class="rowend">
            <text-item txt="Proxy" styles=""/>
          </div>
          <div class="row gap-06">
            <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctSiteFindingProxy)">
            <text-item :txt="expr.sctSiteFindingProxyTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSiteFindingProxy"/>
          </buttonGroup>
          </div>
          <div class="rowend">
            <text-item txt="Elément" styles=""/>
          </div>
          <div class="row gap-06">
            <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctSiteFinding)">
              <text-item :txt="expr.sctSiteFindingTerm"/>
              <text-item  class="main-l" txt="/"/>
              <text-item  :txt="expr.sctSiteFinding"/>
            </buttonGroup>
          </div>
        </template>
      </template>

      <!-- Site -->
      <template v-if="expr.sctSite">

        <div class="rowend mtop-10">
          <text-item txt="Site / Specimen" styles="font-mBold"/>
        </div>
        <div class="row gap-06 mtop-10">
          <text-item :txt="expr.siteRootGroup" styles="main-m"/>
          <text-item  class="main-l" txt="-"/>
          <text-item :txt="expr.siteRoot" styles="main-m"/>
        </div>

        <template v-if="expr.laterality">
          <div class="rowend mtop-02">
            <text-item txt="Latéralité" styles=""/>
          </div>
          <div>
            <text-item :txt="expr.laterality" styles="main-m"/>
          </div>
        </template>

        <template v-if="expr.sctSiteProxy">
        <div class="rowend mtop-02">
          <text-item txt="Proxy" styles=""/>
        </div>
        <div>
          <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctSiteProxy)">
            <text-item :txt="expr.sctSiteProxyTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSiteProxy"/>
          </buttonGroup>
        </div>
        </template>

        <div class="rowend  mtop-05">
          <text-item txt="Elément" styles=""/>
        </div>
        <div class="row gap-10">
          <buttonGroup class="row gap-06 padButton-m" v-if="expr.sctSite" styles="border-vl" @click="sctFct(expr.sctSite)">
            <text-item :txt="expr.sctSiteTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSite"/>
          </buttonGroup>
        </div>
      </template>

      <!-- Aggressor -->
      <template v-if="isAggressor">
        <div class="rowend mtop-10">
          <text-item txt="Aggressor" styles="font-mBold"/>
        </div>
        <div class="row mtop-10 gap-06">
          <text-item :txt="expr.aggressorRootGroup" styles="main-m"/>
          <text-item  class="main-l" txt="-"/>
          <text-item :txt="expr.aggressorRoot" styles="main-m"/>

          <template v-if="expr.aggressorContentRoot !== 'None'">
            <text-item txt="Content:" styles="main-m" class="mleft-20"/>
            <text-item :txt="expr.aggressorContentRoot" styles="main-m"/>            
          </template>
        </div>


        <div class="rowend mtop-02">
          <text-item txt="Proxy" styles=""/>
        </div>
        <div class="row gap-10">
          <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctAggressorProxy)">
            <text-item class="main-l" txt="MainAgg"/>
            <text-item :txt="expr.sctAggressorProxyTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctAggressorProxy"/>
          </buttonGroup>
          <buttonGroup styles="border-vl" class="row gap-06 padButton-m" v-if="expr.sctAggressorContentProxy" @click="sctFct(expr.sctAggressorContentProxy)">
            <text-item class="main-l" txt="ContAgg"/>
            <text-item :txt="expr.sctAggressorContentProxyTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctAggressorContentProxy"/>
          </buttonGroup>
        </div>

        <div class="rowend mtop-05">
          <text-item txt="Elément" styles=""/>
        </div>
        <div class="row gap-10">
          <buttonGroup v-if="expr.sctSubstanceReaction" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstanceReaction)">
            <text-item class="main-l" txt="SR"/>
            <text-item :txt="expr.sctSubstanceReactionTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstanceReaction"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctNestingAggressor" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctNestingAggressor)">
            <text-item class="main-l" txt="NAgg"/>
            <text-item :txt="expr.sctNestingAggressorTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctNestingAggressor"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctAggressor" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctAggressor)">
            <text-item class="main-l" txt="Agg"/>
            <text-item :txt="expr.sctAggressorTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctAggressor"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctSubstance1" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstance1)">
            <text-item class="main-l" txt="S1"/>
            <text-item :txt="expr.sctSubstance1Term"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstance1"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctSubstance2" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstance2)">
            <text-item class="main-l" txt="S2"/>
            <text-item :txt="expr.sctSubstance2Term"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstance2"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctSubstance3" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstance3)">
            <text-item class="main-l" txt="S3"/>
            <text-item :txt="expr.sctSubstance3Term"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstance3"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctSubstance4" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstance4)">
            <text-item class="main-l" txt="S4"/>
            <text-item :txt="expr.sctSubstance4Term"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstance4"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctSubstance5" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstance5)">
            <text-item class="main-l" txt="S5"/>
            <text-item :txt="expr.sctSubstance5Term"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstance5"/>
          </buttonGroup>
          <buttonGroup v-if="expr.sctSubstance6" class="row gap-06 padButton-m" styles="border-vl" @click="sctFct(expr.sctSubstance6)">
            <text-item class="main-l" txt="S6"/>
            <text-item :txt="expr.sctSubstance6Term"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctSubstance6"/>
          </buttonGroup>
        </div>
      </template>


      <!-- FindingProcedure -->
      <template v-if="expr.findingProcedureRoot !== 'None'">
        <div class="rowend mtop-10">
          <text-item txt="Finding procedure" styles="font-mBold"/>
        </div>
        <div class="mtop-10">
          <text-item :txt="expr.findingProcedureRoot" styles="main-m"/>
        </div>
        <template v-if="expr.sctFindingProcedureProxy">
          <div class="rowend mtop-02">
            <text-item txt="Proxy" styles=""/>
          </div>
          <div >
            <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctFindingProcedureProxy)">
              <text-item :txt="expr.sctFindingProcedureProxyTerm"/>
              <text-item  class="main-l" txt="/"/>
              <text-item  :txt="expr.sctFindingProcedureProxy"/>
            </buttonGroup>
          </div>
        </template>
        <template v-if="expr.sctFindingProcedure">
          <div class="rowend mtop-02">
            <text-item txt="Procédure" styles=""/>
          </div>
          <div>
            <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctFindingProcedure)">
              <text-item :txt="expr.sctFindingProcedureTerm"/>
              <text-item  class="main-l" txt="/"/>
              <text-item  :txt="expr.sctFindingProcedure"/>
            </buttonGroup>
          </div>
        </template>
        <template v-if="expr.sctLabCollection">
          <div class="rowend mtop-02">
            <text-item txt="Prélèvement" styles=""/>
          </div>
          <div>
            <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctLabCollection)">
              <text-item :txt="expr.sctLabCollectionTerm"/>
              <text-item  class="main-l" txt="/"/>
              <text-item  :txt="expr.sctLabCollection"/>
            </buttonGroup>
          </div>
        </template>
      </template>

      <!-- Contexte -->
      <div class="rowend mtop-10">
        <text-item txt="Contexte" styles="font-mBold"/>
      </div>
      <div>
        <text-item txt="" styles="font-mBold"/>
      </div>

      <div class="rowend mtop-02">
        <text-item txt="Langue" styles=""/>
      </div>
      <div>
        <buttonGroup v-if="expr.languageIso" styles="border-vl" class="padButton-m">
          <text-item :txt="expr.languageIso"/>
        </buttonGroup>
      </div>

      <template v-if="expr.sctPersonSubject">
        <div class="rowend mtop-02">
          <text-item txt="Sujet" styles=""/>
        </div>
        <div>
          <buttonGroup styles="border-vl" class="padButton-m" @click="sctFct(expr.sctPersonSubject)">
            <text-item :txt="expr.sctPersonSubjectTerm"/>
          </buttonGroup>
        </div>
      </template>

      <template v-if="expr.sctPersonInformer">
        <div class="rowend mtop-02">
          <text-item txt="Rapporteur" styles=""/>
        </div>
        <div>
          <buttonGroup styles="border-vl" class="padButton-m" @click="sctFct(expr.sctPersonInformer)">
            <text-item :txt="expr.sctPersonInformerTerm"/>
          </buttonGroup>
        </div>
      </template>
      <template v-if="expr.timelineStart">
        <div class="rowend mtop-02">
          <text-item txt="Précisions" styles=""/>
        </div>
        <div class="row gap-10">
          <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctCertaintyContext)">
            <text-item :txt="expr.sctCertaintyContextTerm ? expr.sctCertaintyContextTerm : `∅ incertitude`"/>
            <text-item  class="main-l" txt="/"/>
            <text-item :txt="expr.sctProcedureContextTerm ? expr.sctProcedureContextTerm : `∅ contexte de procédure`"/>
            <text-item  class="main-l" txt="=>"/>
            <text-item :txt="expr.isFact ? 'Fait' : `∅ Fait`"/>
          </buttonGroup>
          <buttonGroup styles="border-vl" class="padButton-m">
            <text-item :txt="expr.isNegated ? 'Négation' : 'Sans négation'"/>
          </buttonGroup>
          <buttonGroup styles="border-vl" class="row gap-06 padButton-m">
            <text-item :txt="expr.isNegated ? 'Négation' : '∅ négation'"/>
            <text-item  class="main-l" txt="+"/>
            <template v-if="expr.normalityType === 'None'">
              <text-item txt="∅ normalityType"/>
            </template>
            <template v-else>
              <text-item :txt="expr.normalityType"/>
              <text-item  class="main-l" txt="=>"/>
              <text-item :txt="expr.isNormal ? 'Normal' : 'Anormal'"/>
            </template>
          </buttonGroup>
          <buttonGroup styles="border-vl" class="padButton-m">
            <text-item :txt="expr.isNumerical ? 'Numérique' : '∅ numérique'"/>
          </buttonGroup>
        </div>

        <div class="rowend mtop-02">
          <text-item txt="Date" styles=""/>
        </div>
        <div class="row gap-10">
          <buttonGroup v-if="expr.timelineStart" styles="border-vl" class="padButton-m">
            <text-item :txt="expr.timelineStart.slice(0, 10)"/>
          </buttonGroup>
          <text-item txt="au"/>
          <buttonGroup v-if="expr.timelineStart" styles="border-vl" class="padButton-m">
            <text-item :txt="expr.timelineEnd.slice(0, 10)"/>
          </buttonGroup>
          <buttonGroup v-if="expr.timelineStart" styles="border-vl" class="padButton-m">
            <text-item :txt="expr.durationType"/>
          </buttonGroup>
        </div>
      </template>

      <!-- Détails -->
      <div class="rowend mtop-10">
        <text-item txt="Détails" styles="font-mBold"/>
      </div>
      <div>
        <text-item txt="" styles="font-mBold"/>
      </div>

      <div class="rowend mtop-02">
        <text-item txt="ProxyKey" styles=""/>
      </div>
      <div class="mtop-01">
        <text-item :txt="expr.sctProxyKey" styles="main-m"/>
      </div>

      <template v-if="expr.sctLabKey">
        <div class="rowend mtop-02">
          <text-item txt="LabKey" styles=""/>
        </div>
        <div class="mtop-01">
          <text-item :txt="expr.sctLabKey" styles="main-m"/>
        </div>
      </template>

      <template v-if="expr.sctMorphology">
        <div class="rowend mtop-02">
          <text-item txt="Morphologie" styles=""/>
        </div>
        <div>
          <buttonGroup styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctMorphology)">
            <text-item :txt="expr.sctMorphologyTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctMorphology"/>
          </buttonGroup>
        </div>
      </template>

      <template v-if="expr.numericalValue || expr.sctUnit || expr.sctBodyQualifier">
        <div class="rowend mtop-02">
          <text-item txt="Numérique" styles=""/>
        </div>
        <div class="row gap-10">
          <buttonGroup v-if="expr.sctBodyQualifier" styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctBodyQualifier)">
            <text-item :txt="expr.sctBodyQualifierTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctBodyQualifier"/>
          </buttonGroup>
          <text-item v-if="expr.numericalValue" :txt="expr.numericalValue"/>
          <buttonGroup v-if="expr.sctUnit" styles="border-vl" class="row gap-06 padButton-m" @click="sctFct(expr.sctUnit)">
            <text-item :txt="expr.sctUnitTerm"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctUnitTermFr"/>
            <text-item  class="main-l" txt="/"/>
            <text-item  :txt="expr.sctUnit"/>
          </buttonGroup>
          <buttonGroup v-if="expr.ucumUnit" styles="border-vl" class="row gap-06 padButton-m">
            <text-item  class="main-l" txt="UCUM:"/>
            <text-item  :txt="expr.ucumUnit"/>
          </buttonGroup>
        </div>
      </template>

    </div>

    <div>

    </div>
  </div>
</template>



<script setup>
  import { computed } from 'vue';
  import gen from '@/functions/general.js';
  
  const props = defineProps({
    content: {
      type: Object,
      required: true,
    },
  })

  const expr = computed(() => {
    return props.content
  })

  const siteFindingRoot = computed(() => {
    switch (props.content.siteFindingRoot) {
      case "None":
        return ""
      default:
        return props.content.siteFindingRoot
    }
  })

  const isAggressor  = computed(() => {
    return Boolean(props.content.sctAggressor) || Boolean(props.content.sctSubstance1)
  })


  //Actions
  function sctFct(sctid) {
    let sctServer = "https://ontoserver.csiro.au/shrimp/?concept="
    let url = sctServer + sctid
    window.open(url)
  }
  function fullExprToConsole () {
    const logContent = gen.deepCopy(props.content)
    console.log(logContent)
  }

</script>


<style scoped>
.subgrid {
display: grid;
grid-column-gap: 2rem;
grid-template-columns: max-content max-content;
}
</style>